import { render } from "./ModalServicio.vue?vue&type=template&id=130944ca&scoped=true"
import script from "./ModalServicio.vue?vue&type=script&lang=js"
export * from "./ModalServicio.vue?vue&type=script&lang=js"

import "./ModalServicio.vue?vue&type=style&index=0&id=130944ca&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130944ca"]])

export default __exports__